import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { LoginContentContainerComponent } from '../../../../shared/components/login-content-container/login-content-container.component';
import { NgTemplateOutlet } from '@angular/common';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './user-registration-feedback.component.html',
    styleUrls: ['./user-registration-feedback.component.scss'],
    imports: [LoginContentContainerComponent, NgTemplateOutlet, ButtonComponent, TranslateModule]
})
export class UserRegistrationFeedbackComponent {

  username: string;

  constructor(private _router: Router,  private customNavigationService: CustomNavigationService) {
    const pageState = _router.getCurrentNavigation()?.extras.state;
    this.username = pageState && pageState.username;
  }


  returnToSignIn() {
    this.customNavigationService.navigate(['/main']);
  }
}
